import React, { useEffect, useState } from "react";
import { PropTypes } from "prop-types";
import css from "../../common/anomalyMagneticStyle.less";
import CustomTimeStamp from "../../../../../../generics/TimeStamp/customTimeStamp";
import {
  displayDateTime,
  backtoSevenDays,
} from "../../../../../../utils/displayTime";
import { getCiuPayload } from "../../../../../../config/reqConfig/anomalyDetection";
import ApiService from "../../../../../../config/api-config";
import Spinner from "../../../../../../common/Spinner";
import ErrorComponent from "../../../../../../common/ErrorComponent";
import NoDataAvailable from "../../../../../../common/NoDataAvailable";
import ADUsageLineChart from "../../genericComponents/ADUsageLineChart";
import { getCIUChartData } from "../../common/adUtils";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import useI18n from "../../../../../../i18n/useI18n";

const [HbrBadge] = reactWrapper(["hbr-badge"]);
const CellularInterfaceUsageCharts = (props) => {
  const { tViews } = useI18n("views");
  const [timePeriod, setTimePeriod] = useState([]);
  const [ciuError, setCiuError] = useState(null);
  const [ciuLoader, setCiuLoader] = useState(null);
  const [ciuChartData, setCiuChartData] = useState([]);

  useEffect(() => {
    if (props.selectedHour) {
      setCiuLoader(true);
      setCiuChartData([]);
    }
  }, [props.selectedHour]);

  useEffect(() => {
    const runEffect = async () => {
      let ciuProps = props.cellularInterfaceProps;
      if (ciuProps?.circuitName) {
        try {
          let timePeriod = backtoSevenDays();
          setTimePeriod(timePeriod);
          setCiuLoader(true);
          let ciuPayload = getCiuPayload(timePeriod, ciuProps.circuitName);
          let res = await ApiService.getCellularInterfaceUsage(ciuPayload);
          if (!res.errorObject) {
            if (res?.data?.data.length > 0) {
              let processedData = getCIUChartData(res?.data?.data, timePeriod);
              setCiuChartData(processedData);
            } else {
              setCiuChartData([]);
            }
          } else {
            setCiuError(res.errorObject);
          }
        } catch (error) {
          setCiuError(error);
        } finally {
          setCiuLoader(false);
        }
      }
    };

    runEffect();
  }, [props.cellularInterfaceProps.circuitName]);

  return (
    <div
      className={css["ad-ciu"]}
      role="region"
      aria-label={tViews("usageBasedAD.cellularInterface")}
    >
      <div className={css["ad-ciu-chart"]}>
        {ciuLoader ? (
          <Spinner />
        ) : ciuError ? (
          <ErrorComponent role="alert" />
        ) : ciuChartData?.length > 0 ? (
          <div>
            {props?.cellularInterfaceProps?.circuitName && (
              <div>
                <h2>
                  {tViews("usageBasedAD.cellularInterface")}
                  {tViews("postSpace")}
                  <HbrBadge
                    slot="suffix"
                    pill
                    size="small"
                    aria-hidden="true"
                    data-testid="usage-based-ad-circuit-badge"
                  >
                    <span
                      dangerouslySetInnerHTML={{
                        __html: `${tViews("usageBasedAD.Circuit")}: <span id="va_ad_usage_circuit_name">${props.cellularInterfaceProps.displayCircuitName}</span>`,
                      }}
                    />
                  </HbrBadge>
                  {tViews("postSpace")}
                  <HbrBadge
                    slot="suffix"
                    pill
                    size="small"
                    aria-hidden="true"
                    data-testid="usage-based-ad-site-badge"
                  >
                    <span
                      dangerouslySetInnerHTML={{
                        __html: `${tViews("usageBasedAD.Site")}: <span id="va_ad_usage_site_name">${props.cellularInterfaceProps.displaySiteName}</span>`,
                      }}
                    />
                  </HbrBadge>
                </h2>
                {timePeriod.length > 0 && (
                  <div className="timestamp">
                    <CustomTimeStamp
                      prevTime={displayDateTime(timePeriod[0])}
                      currentTime={displayDateTime(timePeriod[1])}
                    />
                    <div className="ad-timePeriodTxt">{`${tViews("app360.afHeatmapTimePriodText")}`}</div>
                  </div>
                )}
              </div>
            )}
            <ADUsageLineChart
              id="circuit-usage"
              data={ciuChartData}
              anomaly_legend={true}
              selectedHour={props.selectedHour}
              timePeriod={timePeriod}
            />
          </div>
        ) : (
          <NoDataAvailable />
        )}
      </div>
    </div>
  );
};

CellularInterfaceUsageCharts.propTypes = {
  cellularInterfaceProps: PropTypes.object.isRequired,
  refresh: PropTypes.bool,
  selectedHour: PropTypes.string,
};

export default CellularInterfaceUsageCharts;
